/********************************************************************
 * ADOBE CONFIDENTIAL
 * __________________
 *
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *******************************************************************/

import { RegionTransform } from '../data/models';

type InputData = Record<string, any>;

export default (input: InputData, regions: RegionTransform[]): InputData => {
  const transformedData: InputData = {};

  for (const key in input) {
    if (Object.prototype.hasOwnProperty.call(input, key)) {
      const value = input[key];

      if (key === 'region' && value.regionId) {
        const foundRegion = regions.find(
          (region) => region?.id === value.regionId
        );
        if (foundRegion) {
          transformedData[key] = {
            ...value,
            text: foundRegion.text,
          };
        } else {
          transformedData[key] = value;
        }
      } else if (Array.isArray(value)) {
        transformedData[key] = value[0] || '';
        value.slice(1).forEach((val: any, index: number) => {
          transformedData[`${key}Multiline_${index + 2}`] = val;
        });
      } else {
        transformedData[key] = value;
      }
    }
  }

  return transformedData;
};
